import React from 'react';
import { Award, ShieldCheck, Truck, BadgeCheck, Star } from 'lucide-react';
import { FEATURES, TESTIMONIALS } from '../data/mock';

const ICONS = { Award, ShieldCheck, Truck, BadgeCheck };

export const FeaturesSection = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 py-12">
      <div className="text-center mb-8 max-w-2xl mx-auto">
        <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Nasze atuty</span>
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mt-2 mb-2 tracking-tight">Dlaczego nasz sklep?</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {FEATURES.map((f, i) => {
          const Icon = ICONS[f.icon];
          return (
            <div key={i} className="group relative bg-white rounded-2xl p-5 border border-blue-100 hover:border-blue-300 hover:shadow-lg hover:shadow-blue-100 transition-all">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500 to-sky-400 flex items-center justify-center shadow-md shadow-blue-200 mb-3 group-hover:scale-110 transition-transform">
                <Icon className="w-5 h-5 text-white" />
              </div>
              <h3 className="font-bold text-slate-900 mb-1.5 text-sm">{f.title}</h3>
              <p className="text-xs text-slate-600 leading-relaxed">{f.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export const TestimonialsSection = () => {
  return (
    <section className="bg-gradient-to-b from-blue-50/50 to-white py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-widest">Opinie</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mt-3 mb-4 tracking-tight">Co mówią nasi klienci</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 border border-blue-100 hover:shadow-xl hover:shadow-blue-100 transition">
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-blue-500 text-blue-500" />
                ))}
              </div>
              <p className="text-slate-700 mb-5 leading-relaxed">„{t.text}”</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-sky-400 flex items-center justify-center text-white font-bold">{t.name[0]}</div>
                <div>
                  <div className="font-semibold text-slate-900 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const TelegramCTA = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 to-sky-500 p-10 sm:p-14 text-white">
        <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-60 h-60 rounded-full bg-white/10 blur-3xl" />
        <div className="relative grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-3xl sm:text-4xl font-bold mb-4 tracking-tight">Skontaktuj się z nami na Telegramie</h3>
            <p className="text-blue-100 leading-relaxed mb-6">
              Po zakup i więcej informacji zapraszamy na nasz Telegram. Żadnych danych na stronie, pełna dyskrecja i szybka odpowiedź.
            </p>
            <a href="https://t.me/+9A5CpRihCfNjMzc0" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-white text-blue-600 hover:bg-blue-50 px-7 py-3.5 rounded-full font-semibold shadow-xl transition">
                Otwórz Telegram
            </a>
          </div>
          <div className="hidden md:flex justify-end">
            <svg viewBox="0 0 200 200" className="w-48 h-48">
              <circle cx="100" cy="100" r="90" fill="#ffffff" opacity="0.1" />
              <circle cx="100" cy="100" r="70" fill="#ffffff" opacity="0.15" />
              <path d="M 60 100 L 145 65 L 130 140 L 95 120 L 80 135 L 80 115 L 130 80 L 90 110 Z" fill="#ffffff" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};
